import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import PropTypes from 'prop-types';

import '../../utils/styles/Carousel.css';

// Define navigation option based on screen size
const navigationOptions = window.innerWidth >= 768;

function Carousel({ items, loop }) {
    return (
        <Swiper
            className="swiper-style"
            direction="horizontal"
            breakpoints={{
                0: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                1000: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1350: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
            }}
            modules={[Autoplay, Pagination, Navigation]}
            loop={loop}
            autoplay={{
                delay: 2500,
                disableOnInteraction: false,
            }}
            pagination={{ clickable: true }}
            navigation={navigationOptions}
        >
            {items.map((item) => (
                <SwiperSlide key={item.id}>
                    <div className="center-slide">{item.content}</div>
                </SwiperSlide>
            ))}
        </Swiper>
    );
}

Carousel.propTypes = {
    items: PropTypes.array.isRequired,
    loop: PropTypes.bool,
};

export default Carousel;
